import React from 'react';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-fetching-library';
import { Typography, Box, Stack, Button, TextField, Alert, Checkbox, CardHeader, Card, CardContent, FormControlLabel, Tooltip } from '@mui/material';
import {
  getLatestFormAction,
  getOrderDocumentAction
} from '../../../services/request';
import { FormPanel } from '../../../components/form/FormPanel';
import { useResponsive } from '../../../services/hooks';
import { Logo } from '../../../components/landing/Logo';
import Form from '../../../components/json-forms/Form';
import InfoIcon from '@mui/icons-material/Info';


const Header = () => {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      justifyContent="space-between"
      alignItems="center"
      p={2}
    >
      <Logo />
      {/* <Button variant="text" href="http://zielone-szkoly.com/" target="_blank" style={{ color: 'rgb(0, 171, 85)' }}>Powrót do strony zielone-szkoly.com</Button> */}
      {/* <Typography variant="h4"> Karta karta_kwalifikacyjna uczesnika</Typography> */}
    </Stack>
  );
};

const QualificationCardPage = ({ formIdentifier, year }) => {
  const { loading, payload, error } = useQuery(
    getLatestFormAction(formIdentifier, year)
  );
  const { id } = useParams();
  const {
    loading: documentLoading,
    payload: documentPayload,
    error: documentError
  } = useQuery(getOrderDocumentAction(id, formIdentifier));
  const [validPassword, setValidPassword] = React.useState('');
  const [loadPreviousYearsCardData, setLoadPreviousYearsCardData] = React.useState(true);
  const [canBeMidified, setCanBeMidified] = React.useState(false);
  const [form, setForm] = React.useState(null);
  const [documentData, setDocumentData] = React.useState(null);
  const [isPasswordValid, setIsPasswordValid] = React.useState(false);
  const [invalidPassword, setInvalidPassword] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [isDraft, setIsDraft] = React.useState(false);
  const isDesktop = useResponsive('up', 'lg');

  const handleChange = e => setPassword(e.target.value);
  const handleClick = e => {
    if (password === validPassword) {
      setIsPasswordValid(true);
    } else {
      setInvalidPassword(true);
    }
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setForm(payload);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!documentError && !documentLoading) {
      setDocumentData(documentPayload.json_data);
      setValidPassword(documentPayload.secret_key);
      setIsDraft(documentPayload.is_draft);
      const completingDateTo = new Date(documentPayload.completing_date_to);
      completingDateTo.setDate(completingDateTo.getDate() + 1);
      if (completingDateTo >= new Date()) {
        setCanBeMidified(true);
      }
    }
  }, [documentLoading]);

  if (error) {
    return <Typography>Nie udało się załadować formularza</Typography>;
  }

  // if (documentData) {
  //   if (documentData && Object.keys(documentData).length <= 1) {
  //     window.alert('czy chcesz wczytać dane?');
  //   };
  // };


  return (
    <>
      {!isPasswordValid ? (
        <Box sx={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Stack spacing={2} alignItems="center">
            <Logo />
            {form != null ? (
              <>
                {!isPasswordValid && validPassword && canBeMidified ? (
                  <Card sx={{ width: '440px', margin: 'auto' }}>
                    <CardHeader title={`${formIdentifier === 'qualification_card' ? 'PODAJ OTRZYMANY W SMS KOD' : 'PODAJ OTRZYMANY W E-MAILU KOD DOSTĘPU DO DOKUMENTU'}`} />
                    <CardContent>
                      <TextField
                        type="password"
                        onChange={handleChange}
                        value={password}
                        fullWidth
                        inputProps={{ style: { textAlign: 'center', fontSize: '26px' }, maxLength: 16 }}
                      />
                      {/* <FormControlLabel
                        control={
                          <Checkbox
                            name="only_extend"
                            checked={loadPreviousYearsCardData}
                            onChange={() => setLoadPreviousYearsCardData(!loadPreviousYearsCardData)}
                          />
                        }
                        label={
                          <Stack direction="row" alignItems="center">
                            Wczytaj dane z poprzednich lat
                            <Tooltip
                              title={
                                'Jeśli zaznaczysz tę opcję, a w poprzednich latach wypełniałeś już kartę kwalifikacyjną, to Twoje dane zostaną automatycznie wczytane do formularza. Jeśli nie chcesz, aby tak się stało, odznacz tę opcję.'
                              }
                              placement="right"
                            >
                              <InfoIcon sx={{ ml: 1, fontSize: 24 }} color="info" />
                            </Tooltip>
                          </Stack>
                        }
                      /> */}
                      {invalidPassword ? (
                        <Alert severity="error" sx={{ width: '300px' }}>
                          niepoprawne hasło
                        </Alert>
                      ) : null}
                      <Box height={20}/>
                      <Button
                        disabled={password.length != 8 }
                        variant="contained"
                        onClick={handleClick}
                        sx={{ width: '390px' }}
                      >
                        POKAŻ FORMULARZ
                      </Button>
                    </CardContent>
                  </Card>
                ) : null}
                {!canBeMidified ? (
                  <Stack
                    justifyContent="center"
                    alignItems="center"
                    spacing={4}
                    mt={8}
                  >
                    <Alert severity="error" sx={{ width: '300px' }}>
                      Dokument nie jest obecnie dostępny.
                    </Alert>
                  </Stack>
                ) : null}
              </>
            ) : null}
          </Stack>
        </Box>)
        : (
          <div
            style={
              isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}
            }
          >
            <Form
              identifier="karta_kwalifikacyjna"
              admin={false}
              version={null}
              initData={documentData}
              password={password}
              isDraft={isDraft}
            />
          </div>
        )}
    </>
  );
};

export default QualificationCardPage;
